export const formatDate = (dateString) => {
  // console.log(dateString);
  if (dateString === "All") {
    return "All";
  } else {
    const date = new Date(dateString);
    const year = date.getUTCFullYear();
    const month = String(date.getUTCMonth() + 1).padStart(2, "0");
    return `${year}-${month}`;
  }
};

export const formatNumber = (number) => {
  return new Intl.NumberFormat().format(number);
};

export const formatYearMonth = (input) => {
  // input example: "2025 - 05"
  const [year, month] = input.split("-").map((s) => s.trim());
  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  // month is 1-based, array is 0-based
  const monthIndex = parseInt(month, 10) - 1;
  return `${monthNames[monthIndex]} ${year}`;
};

export const extractYear = (dateStr) => {
  return dateStr.split("-")[0];
};

export const getQuarter = (yearMonth) => {
  const [year, monthStr] = yearMonth.split("-");
  const month = parseInt(monthStr, 10);

  const quarter = Math.ceil(month / 3); // 1..4

  return `Q${quarter} - ${year}`;
};

export const getQuarterByMonth = (month) => {
  const monthInt = parseInt(month, 10);
  if (isNaN(monthInt) || monthInt < 1 || monthInt > 12) {
    console.error("Invalid month in getQuarter:", month);
    return null;
  }
  return Math.ceil(monthInt / 3); // 1..4
};

// export const getQuarter = (month) => {
//   try {
//     if (!yearMonth) throw new Error("Input is empty or undefined");

//     const str = String(yearMonth); // ensure it's a string
//     const [year, monthStr] = str.split("-");
//     const month = parseInt(monthStr, 10);

//     if (isNaN(month) || !year) {
//       throw new Error(`Invalid input: ${str}`);
//     }

//     const quarter = Math.ceil(month / 3);
//     return `QUARTER ${quarter} - ${year}`;
//   } catch (e) {
//     console.error("Error in getQuarter:", e.message, "\nInput:", yearMonth);
//     return null;
//   }
// };

export const formatFloatNumber = (number) => {
  const value = Number(number);

  if (isNaN(value)) return "0.00";

  return value.toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};


export const createRevenueDateTitle = (
  firstRevenueYearMonth,
  lastRevenueYearMonth,
  fromDate,
  toDate
) => {
  if (fromDate === "All") {
    return (
      formatYearMonth(firstRevenueYearMonth) +
      " - " +
      formatYearMonth(lastRevenueYearMonth)
    );
  } else if (fromDate === toDate) {
    return formatYearMonth(fromDate);
  } else {
    return formatYearMonth(fromDate) + " - " + formatYearMonth(toDate);
  }
};

export const formatDateMMDDYYYY = (date) => {
  // Accepts Date object → returns "MM/DD/YYYY"
  const mm = String(date.getMonth() + 1).padStart(2, "0");
  const dd = String(date.getDate()).padStart(2, "0");
  const yyyy = date.getFullYear();
  return `${mm}/${dd}/${yyyy}`;
};

export const createYearToYearTitle = (fromDate, toDate) => {
  if (
    fromDate &&
    fromDate.trim().toLowerCase() !== "null" &&
    fromDate.trim().toLowerCase() !== "nan"
  ) {
    return Number.NaN;
  } else {
    const fromYear = extractYear(fromDate);
    const toYear = extractYear(toDate);

    return `${fromYear} - ${toYear}`;
  }
};

export const createRevenueCardYearTitle = (
  firstRevenueYearMonth,
  lastRevenueYearMonth,
  fromDate,
  toDate
) => {
  const firstYear = extractYear(firstRevenueYearMonth);
  const lastYear = extractYear(lastRevenueYearMonth);
  if (fromDate === "All") return "YEAR-TO-DATE " + firstYear + " - " + lastYear;
  const fromYear = extractYear(fromDate);
  const toYear = extractYear(toDate);

  if (fromYear === toYear) {
    return "YEAR-TO-DATE " + fromYear;
  } else {
    return "YEAR-TO-DATE " + fromYear + " - " + toYear;
  }
};

export const createRevenueCardQuarterTitle = (
  firstRevenueYearMonth,
  lastRevenueYearMonth,
  fromDate,
  toDate
) => {
  const firstQuarter =
    firstRevenueYearMonth > "2024-01"
      ? getQuarter("2024-01")
      : getQuarter(firstRevenueYearMonth);
  const lastQuarter = getQuarter(lastRevenueYearMonth);

  if (fromDate === "All") return firstQuarter + " to " + lastQuarter;

  const quarterFromDate = getQuarter(fromDate);
  const quarterToDate = getQuarter(toDate);

  if (quarterFromDate !== quarterToDate) {
    return quarterFromDate + " to " + quarterToDate;
  } else {
    return quarterFromDate;
  }
};

export const createRevenueCardMonthTitle = (
  firstRevenueYearMonth,
  lastRevenueYearMonth,
  fromDate,
  toDate
) => {
  if (fromDate === "All") {
    const [fromFirstYear, formFirstMonth] = firstRevenueYearMonth
      .split("-")
      .map(Number);
    const [fromLastYear, formLastMonth] = lastRevenueYearMonth
      .split("-")
      .map(Number);
    const fromFirst = new Date(fromFirstYear, formFirstMonth - 1, 1);
    const toLast = new Date(fromLastYear, formLastMonth, 0);
    return `(${formatDateMMDDYYYY(fromFirst)} - ${formatDateMMDDYYYY(toLast)})`;
  }

  const [fromYear, fromMonth] = fromDate.split("-").map(Number);
  const [toYear, toMonth] = toDate.split("-").map(Number);

  const from = new Date(fromYear, fromMonth - 1, 1); // first day of from month
  const to = new Date(toYear, toMonth, 0); // last day of to month

  return `(${formatDateMMDDYYYY(from)} - ${formatDateMMDDYYYY(to)})`;
};

export const toMillionFormat = (value) => {
  try {
    if (value == null || value === "") return "0";

    // Clean input (remove commas, spaces, symbols)
    const cleaned = String(value).replace(/[^0-9.-]+/g, "");
    const num = Number(cleaned);

    if (isNaN(num)) {
      console.error("Invalid number input:", value);
      return "0";
    }

    if (Math.abs(num) < 1_000_000) {
      // Show as thousands if less than 1 million
      return `${(num / 1_000).toFixed(2)}K`;
    } else {
      // Show as millions otherwise
      return `${(num / 1_000_000).toFixed(2)}M`;
    }
  } catch (e) {
    console.error("Error in toMillionFormat:", e.message, "| Input:", value);
    return "0";
  }
};

// export const getDefaultDateRange = (fromDate, toDate) => {
//   // example: fromDate = "2024-02", toDate = "2024-05" => return "02/01/2024 - 05/31/2024"
// }
